import { Heart, Stars, Mic } from 'lucide-react';
import { IMAGE_EUGENIA } from '../../constants/social';

export default function About() {
  const pillars = [
    { icon: <Mic className="w-5 h-5" />, label: 'ASMR', desc: 'Sonidos relajantes cuidadosamente seleccionados para calmar la mente.', color: 'text-rose-300', bg: 'bg-rose-400/10' },
    { icon: <Heart className="w-5 h-5" />, label: 'Comunidad', desc: 'Los Eugenialitos son el corazón de cada directo, siempre bienvenidos.', color: 'text-pink-300', bg: 'bg-pink-400/10' },
    { icon: <Stars className="w-5 h-5" />, label: 'Creatividad', desc: 'Cerámica, pintura, mandalas y mucho más en cada stream.', color: 'text-violet-300', bg: 'bg-violet-400/10' },
  ];

  return (
    <section className="relative bg-gradient-to-b from-[#0d0a1a] to-[#0a0815] py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-rose-300/60 text-sm font-medium tracking-[0.2em] uppercase mb-3">Sobre mí</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-white/90 leading-tight">
            Hola, soy{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-300 to-sky-300">Eugenia</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-5 text-slate-300/80 leading-relaxed text-[1.05rem]">
            <p>
              Soy streamer argentina y creadora de contenido ASMR. De lunes a jueves transmito en Twitch
              sesiones diseñadas para ayudarte a desconectarte del ruido del día y entrar en un estado de calma profunda.
            </p>
            <p>
              Los <span className="text-rose-300 font-semibold">canjes del lunes</span> son un ritual especial:
              exploro distintos objetos para crear sonidos relajantes mientras charlamos, y también saco
              <span className="text-sky-300 font-semibold"> cartas de oráculo</span> para quienes lo piden en el chat.
            </p>
            <p>
              Los martes y miércoles me acompaño de actividades manuales y artísticas — cerámica, pintura,
              mandalas — siempre con el micrófono cerca. Los jueves me sumo al ASMR gaming con juegos tranquilos.
              Y los viernes es modo libre: partidas con los <span className="text-rose-300 font-semibold">Eugenialitos</span> y mucha diversión.
            </p>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-rose-400/10 to-sky-400/10 blur-xl" />
            <img
              src={IMAGE_EUGENIA}
              alt="EuGe_NiAL — Eugenia"
              className="relative rounded-3xl w-full object-cover aspect-[4/3] shadow-2xl shadow-black/40"
            />
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-6">
          {pillars.map((p) => (
            <div
              key={p.label}
              className="group p-6 rounded-2xl border border-white/5 bg-white/[0.03] hover:bg-white/[0.06] hover:border-rose-300/20 transition-all duration-300"
            >
              <div className={`inline-flex items-center justify-center w-10 h-10 rounded-xl ${p.bg} ${p.color} mb-4 group-hover:scale-110 transition-transform`}>
                {p.icon}
              </div>
              <h3 className="text-white/90 font-semibold mb-2">{p.label}</h3>
              <p className="text-slate-400/80 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
